import React from "react";
import "./AboutAppSection.css";
import Icons from "../../../../config/images";

const AboutAppSection = () => {
  return (
    <section className="about-app-section">
      <div className="about-app-container">
        {/* Left Content */}
        <div className="about-app-content">
          <h2>
            Technology That Helps Your
            <br />
            <span> Jewellery Business Grow</span>
          </h2>

          <p>
            BA Code Solution builds powerful digital systems designed
            specifically for jewellery businesses. Our solutions simplify
            operations, improve control and help you scale with confidence.
          </p>

          <h3 className="about-app-subheading">What We Focus On</h3>

          <ul className="about-app-list">
            <li>Product Catalogue Management</li>
            <li>Secure Customer Login & Access Control</li>
            <li>Live Gold & Diamond Rate Integration</li>
            <li>Order, Invoice & Stock Management</li>
            <li>Custom ERP & Admin Dashboards</li>
          </ul>

          <p className="about-app-highlight">
            We don’t just build apps — we build systems that grow with your
            business.
          </p>
        </div>

        {/* Right Image */}
        <div className="about-app-image">
          <img src={Icons.mobile_tab_image} alt="Jewellery App Preview" />
        </div>
      </div>
    </section>
  );
};

export default AboutAppSection;
